module.exports = __webpack_public_path__ + "img/PDF.2a94c198.svg";